import styled from 'styled-components';
import { FaPlusSquare } from 'react-icons/fa';
import { FaSquareMinus } from 'react-icons/fa6';
import { HiXMark } from 'react-icons/hi2';
import { GrPowerReset } from 'react-icons/gr';
import { MdOutlineDone } from 'react-icons/md';
import { AiOutlineEdit } from 'react-icons/ai';

// Модальное окно
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
`;

export const ModalContent = styled.div`
  background: ${props => props.switcher ? '#2E2E2E' : '#ffffff'};
  border-radius: 0;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  height: 100vh;
  max-width: none;
  max-height: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const ModalHeader = styled.div`
  padding: 24px 32px 16px;
  border-bottom: 1px solid ${props => props.switcher ? '#404040' : '#e5e7eb'};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalTitle = styled.h2`
  font-family: 'Geologica', sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.switcher ? '#404040' : '#f3f4f6'};
    color: ${props => props.switcher ? '#ffffff' : '#374151'};
  }
`;

export const ModalBody = styled.div`
  padding: 24px 32px;
  overflow-y: auto;
  flex: 1;
  height: calc(100vh - 80px); /* Вычитаем высоту заголовка */
`;

// Информация о чате
export const ChatInfoSection = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  margin-bottom: 32px;
  padding: 20px;
  background: ${props => props.switcher ? '#404040' : '#f9fafb'};
  border-radius: 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
`;

export const ChatInfoLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const ChatId = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  width: fit-content;
`;

export const ChatStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${props => props.switcher ? '#d1d5db' : '#6b7280'};
`;

export const StatusIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.checked ? '#10b981' : '#ef4444'};
`;

// Пользователь
export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  border-radius: 12px;
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  margin-bottom: 24px;
`;

export const UserAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const UserName = styled.h3`
  font-family: 'Geologica', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0 0 4px 0;
`;

export const UserRole = styled.p`
  font-size: 14px;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
  margin: 0;
`;

export const UserStats = styled.div`
  display: flex;
  gap: 16px;
`;

export const StatItem = styled.div`
  text-align: center;
`;

export const StatValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: ${props => props.switcher ? '#9ca3af' : '#6b7280'};
`;

// Прогресс бар
export const ProgressSection = styled.div`
  margin-bottom: 24px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${props => props.switcher ? '#404040' : '#e5e7eb'};
  border-radius: 4px;
  overflow: hidden;
  margin: 8px 0;
`;

export const Progress = styled.div`
  width: ${props => props.percent}%;
  height: 100%;
  background: linear-gradient(90deg, 
    ${props => props.percent > 90 ? '#10b981' : props.percent >= 80 ? '#f59e0b' : '#ef4444'} 0%, 
    ${props => props.percent > 90 ? '#059669' : props.percent >= 80 ? '#d97706' : '#dc2626'} 100%);
  transition: width 0.3s ease;
`;

// Табы
export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.switcher ? '#404040' : '#e5e7eb'};
  margin-bottom: 24px;
`;

export const Tab = styled.button`
  background: none;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.active ? (props.switcher ? '#ffffff' : '#111827') : (props.switcher ? '#9ca3af' : '#6b7280')};
  border-bottom: 2px solid ${props => props.active ? '#667eea' : 'transparent'};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: ${props => props.switcher ? '#ffffff' : '#111827'};
  }
`;

// Контент табов
export const TabContent = styled.div`
  min-height: 60vh;
  max-height: 70vh;
  overflow-y: auto;
`;

// Аналитика
export const AnalyticsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AnalyticsItem = styled.div`
  padding: 16px;
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  border: 1px solid ${props => props.switcher ? '#525252' : '#e5e7eb'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.switcher ? '#525252' : '#f9fafb'};
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const AnalyticsItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const AnalyticsItemTitle = styled.h4`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
  margin: 0;
`;

export const AnalyticsItemScore = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  background: ${props => props.score > 90 ? '#dcfce7' : props.score >= 80 ? '#fef3c7' : '#fee2e2'};
  color: ${props => props.score > 90 ? '#166534' : props.score >= 80 ? '#92400e' : '#991b1b'};
`;

export const AnalyticsItemContent = styled.div`
  font-size: 13px;
  color: ${props => props.switcher ? '#d1d5db' : '#6b7280'};
  line-height: 1.5;
`;

// Чат
export const ChatContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid ${props => props.switcher ? '#404040' : '#e5e7eb'};
  border-radius: 8px;
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  padding: 16px 0;
`;

export const MessageContainer = styled.div`
  display: flex;
  justify-content: ${props => {
    if (props.authorType === 'system') return 'center';
    if (props.authorType === 'bot') return 'flex-start';
    return props.authorType === 'agent' ? 'flex-start' : 'flex-end';
  }};
  margin-bottom: 12px;
  padding: 0 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MessageBubble = styled.div`
  max-width: ${props => props.authorType === 'system' ? '80%' : '70%'};
  padding: 12px 16px;
  border-radius: 18px;
  position: relative;
  word-wrap: break-word;
  
  background: ${props => {
    // Если сообщение приватное, используем желтый цвет
    if (props.isPrivate) {
      return props.switcher ? '#fbbf24' : '#fef3c7';
    }
    
    if (props.authorType === 'system') {
      return props.switcher ? '#525252' : '#e5e7eb';
    } else if (props.authorType === 'bot') {
      return props.switcher ? '#3b82f6' : '#dbeafe';
    } else if (props.authorType === 'agent') {
      return props.switcher ? '#525252' : '#f3f4f6';
    } else if (props.authorType === 'customer') {
      return '#667eea';
    } else {
      return props.switcher ? '#404040' : '#e5e7eb';
    }
  }};
  
  color: ${props => {
    // Если сообщение приватное, используем темный текст
    if (props.isPrivate) {
      return props.switcher ? '#78350f' : '#92400e';
    }
    
    if (props.authorType === 'system') {
      return props.switcher ? '#9ca3af' : '#6b7280';
    } else if (props.authorType === 'bot') {
      return props.switcher ? '#ffffff' : '#1e40af';
    } else if (props.authorType === 'customer') {
      return 'white';
    } else {
      return props.switcher ? '#d1d5db' : '#374151';
    }
  }};
  
  border-bottom-left-radius: ${props => {
    if (props.authorType === 'system') return '18px';
    if (props.authorType === 'bot') return '4px';
    return props.authorType === 'agent' ? '4px' : '18px';
  }};
  border-bottom-right-radius: ${props => {
    if (props.authorType === 'system') return '18px';
    if (props.authorType === 'bot') return '18px';
    return props.authorType === 'agent' ? '18px' : '4px';
  }};
`;

export const MessageHeader = styled.div`
  display: flex;
  justify-content: ${props => (props.authorType === 'agent' || props.authorType === 'bot') ? 'flex-start' : 'flex-end'};
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const MessageAuthor = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: ${props => {
    if (props.authorType === 'agent') {
      return props.switcher ? '#9ca3af' : '#6b7280';
    } else if (props.authorType === 'customer') {
      return 'rgba(255, 255, 255, 0.8)';
    } else {
      return props.switcher ? '#9ca3af' : '#6b7280';
    }
  }};
`;

export const MessageTime = styled.span`
  font-size: 11px;
  color: ${props => {
    if (props.authorType === 'agent') {
      return props.switcher ? '#9ca3af' : '#6b7280';
    } else if (props.authorType === 'customer') {
      return 'rgba(255, 255, 255, 0.7)';
    } else {
      return props.switcher ? '#9ca3af' : '#6b7280';
    }
  }};
`;

export const MessageContent = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: inherit;
`;

// Кнопки действий
export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${props => props.switcher ? '#404040' : '#e5e7eb'};
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  background: ${props => props.variant === 'primary' ? '#667eea' : props.variant === 'success' ? '#10b981' : '#6b7280'};
  color: white;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

// Модальное окно для комментариев
export const CommentModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
`;

export const CommentModalContent = styled.div`
  background: ${props => props.switcher ? '#2E2E2E' : '#ffffff'};
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
`;

export const CommentForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.switcher ? '#ffffff' : '#111827'};
`;

export const Input = styled.input`
  padding: 12px;
  border: 1px solid ${props => props.switcher ? '#404040' : '#d1d5db'};
  border-radius: 8px;
  font-size: 14px;
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

export const TextArea = styled.textarea`
  padding: 12px;
  border: 1px solid ${props => props.switcher ? '#404040' : '#d1d5db'};
  border-radius: 8px;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
  color: ${props => props.switcher ? '#ffffff' : '#111827'};

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
`;

export const SubmitButton = styled.button`
  padding: 12px 24px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #5a67d8;
  }
`;

// Устаревшие компоненты (оставляем для совместимости)
export const SupportMenuConteiner = ModalOverlay;
export const TextInformationBlock = styled.div``;
export const MainText = ModalTitle;
export const IdInformation = ChatId;
export const UserGradeBlock = UserSection;
export const User = styled.div``;
export const UserImg = UserAvatar;
export const UserBlock = UserInfo;
export const UserJobTitle = UserRole;
export const PercentBarBlock = ProgressSection;
export const PercentItem = styled.div``;
export const ResultsBlock = styled.div``;
export const MistakeItem = styled.div``;
export const CorrectItem = styled.div``;
export const AnalyticsBlock = TabContent;
export const AnalyticsMainText = styled.div``;
export const AnalyticsItemConatiner = AnalyticsItem;
export const CommentText = styled.p`
  font-family: 'Geologica', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 1.5;
  color: ${props => props.switcher ? '#d1d5db' : '#6b7280'};
  margin: 0;
`;
export const CommentTextItem = styled.div``;
export const CommentTextItemTags = styled.div``;
export const List = styled.div`
  margin-top: 12px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid ${props => props.switcher ? '#404040' : '#d1d5db'};
  border-radius: 8px;
  background: ${props => props.switcher ? '#404040' : '#ffffff'};
`;
export const Item = styled.div`
  padding: 10px 12px;
  margin: 4px;
  background: ${props => props.selected ? '#667eea' : (props.switcher ? '#525252' : '#f9fafb')};
  color: ${props => props.selected ? 'white' : (props.switcher ? '#ffffff' : '#111827')};
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
  font-size: 14px;

  &:hover {
    background: ${props => props.selected ? '#5a67d8' : (props.switcher ? '#404040' : '#f3f4f6')};
  }

  &:first-child {
    margin-top: 4px;
  }

  &:last-child {
    margin-bottom: 4px;
  }
`;
export const SwitchBar = TabContainer;
export const SwitchButton = Tab;
export const ChatConteiner = ChatContainer;
export const SystemMessage = MessageContainer;
export const AgentMessage = MessageContainer;
export const CustomerMessage = MessageContainer;
export const ChatInfo = MessageHeader;
export const UserChatImg = styled.img``;
export const UserChatName = MessageAuthor;
export const TimeChat = MessageTime;
export const MessageConteiner = styled.div``;
export const CreateAtTitle = styled.div``;
export const CheckedBox = styled.div``;
export const Cross = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  cursor: pointer;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 2px;
    background-color: #ef4444;
    border-radius: 1px;
  }
  
  &::before {
    transform: rotate(45deg);
  }
  
  &::after {
    transform: rotate(-45deg);
  }
`;
export const CheckedButton = ActionButton;
export const ResetIcon = styled(GrPowerReset)``;
export const DoneIcon = styled(MdOutlineDone)`
  width: 20px;
  height: 20px;
  color: #10b981;
  flex-shrink: 0;
`;
export const DecisionButton = ActionButton;
export const DicisionIcon = styled(AiOutlineEdit)``;
export const ArrowButton = styled.button``;
export const ChatCounter = styled.div``;
export const FormFieldd = FormField;
export const Labelll = Label;
export const CheckboxWrapper = styled.div``;

export const Plus = styled(FaPlusSquare)`
  width: 16px;
  height: 16px;
  color: #10b981;
  flex-shrink: 0;
`;

export const Minus = styled(FaSquareMinus)`
  width: 16px;
  height: 16px;
  color: #ef4444;
  flex-shrink: 0;
`;

export const TextBlock = styled.div`
  width: 100%;
`;
